import { render, staticRenderFns } from "./loginPhone.vue?vue&type=template&id=d30d83dc&scoped=true&"
import script from "./loginPhone.vue?vue&type=script&lang=js&"
export * from "./loginPhone.vue?vue&type=script&lang=js&"
import style0 from "./loginPhone.vue?vue&type=style&index=0&id=d30d83dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30d83dc",
  null
  
)

export default component.exports